/** Blue circled reporting-point triangles, rasterized at 2x for MapLibre icons. */
export function reportingPointImage(filled: boolean): { width: number; height: number; data: Uint8Array } {
  const size = 64;
  const data = new Uint8Array(size * size * 4);
  const vertices = [
    [32, 10],
    [12, 47],
    [52, 47],
  ];
  const distance = (x: number, y: number, a: number[], b: number[]) => {
    const dx = b[0] - a[0],
      dy = b[1] - a[1];
    const t = Math.max(0, Math.min(1, ((x - a[0]) * dx + (y - a[1]) * dy) / (dx * dx + dy * dy)));
    return Math.hypot(x - a[0] - t * dx, y - a[1] - t * dy);
  };
  for (let y = 0; y < size; y++)
    for (let x = 0; x < size; x++) {
      let coverage = 0;
      for (const oy of [0.25, 0.75])
        for (const ox of [0.25, 0.75]) {
          const px = x + ox,
            py = y + oy;
          const ring = Math.abs(Math.hypot(px - 32, py - 32) - 27) <= 2;
          const inside = py >= 10 && py <= 47 && Math.abs(px - 32) <= ((py - 10) * 20) / 37;
          const edge = vertices.some((a, i) => distance(px, py, a, vertices[(i + 1) % 3]) <= 1.6);
          if (ring || (filled ? inside : edge)) coverage++;
        }
      data.set([0, 0, 139, Math.round((coverage * 255) / 4)], (y * size + x) * 4);
    }
  return { width: size, height: size, data };
}
